<template>
  <easy-page-template
      title="こちらはヘルプ画面です"
      subtitle="以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconHelpContact"
          title="お問い合わせ"
          href="https://community.ciof-ivi.com/contact/"
          target="_blank"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconHelpDocument"
          title="ドキュメントを閲覧する"
          href="https://community.ciof-ivi.com/download/#documents"
          target="_blank"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconHelpContact from "./assets/icon_help_contact.svg";
import iconHelpDocument from "./assets/icon_help_document.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "HelpHome",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconHelpContact,
      iconHelpDocument,
      imageTradeContract
    }
  },
}
</script>

<style scoped>

</style>
